(function() {
	const delegate = new domDelegate.Delegate(document.body);

	// Track clicks on interactive elements
	const selector = [
		'[data-action]',
		'[aria-haspopup]',
		'nav a',
		'.SectionHeader__Links a',
		'.Slideshow__Slide',
		'.PromotedCollections a',
		'.AnnouncementBar__Content a',
		'#primeai_button',
		'#primeai_button2',
		'[data-section-type=recently-viewed-products]',
		'.ProductRecommendations',
		'.CartUpsell [data-product-handle]',
	].join(', ');
	delegate.on('click', selector, function(event) {
		var target = event.target;
		if (!target.matches(selector)) {
			target = target.closest(selector);
		}
		
		var action, label = null;

		if (target.dataset.action) {
			action = target.dataset.action;
			switch (action) {
				case 'add-to-cart':
					return;
				case 'toggle-collapsible':
				case 'toggle-tab':
					label = target.textContent;
					break;
				case 'select-value':
					label = target.dataset.value;
					var popover = target.closest('.Popover');
					if (popover) label = `${popover.id}: ${label}`;
					break;
				case 'open-drawer':
				case 'close-drawer':
					label = target.dataset.drawerId;
					break;
				case 'open-modal':
				case 'close-modal':
					label = target.getAttribute('aria-controls');
					break;
				case 'add-to-cart-noform':
					label = target.closest('[data-product-handle]')?.dataset.productHandle;
					break;
			}
		} else if (target.ariaHasPopup) {
			action = target.ariaExpanded ? 'open-popover' : 'close-popover';
			label = target.getAttribute('aria-controls');
		} else if (target.matches('nav a')) {
			action = 'nav';
			label = target.childNodes[0].textContent;
			var parent = target.closest('.Collapsible__Inner');
			if (parent) {
				parent = parent.previousElementSibling;
				if (parent.matches('button')) {
					label = `${parent.childNodes[0].textContent} > ${label}`;
				}
			} else {
				var parent = target.closest('.MegaMenu');
				if (parent) {
					parent = parent.previousElementSibling;
					if (parent.matches('a')) {
						label = `${parent.childNodes[0].textContent} > ${label}`;
					}
				}
			}
		} else if (target.matches('.SectionHeader__Links a')) {
			action = 'collection-link';
			label = target.innerText;
		} else if (target.matches('.Slideshow__Slide')) {
			action = target.closest('[data-ga-category]').dataset.gaCategory || 'Slideshow';
			label = `${target.dataset.gaLabel || 'Slide'} (${[...target.parentNode.children].indexOf(target) + 1})`;
		} else if (target.matches('.PromotedCollections a')) {
			action = 'promoted-collection';
			label = target.closest('.PromotedCollections')?.querySelector('.SectionHeader__Heading')?.innerText || target.closest('.PromotedCollections')?.querySelector('.SectionHeader a')?.href.split('/').pop();
		} else if (target.matches('.AnnouncementBar__Content a')) {
			action = 'announcement';
			if (target.closest('#section-announcement-bottom')) {
				action += '-bottom';
			} else if (target.closest('#sidebar-menu')) {
				action += '-mobile-nav';
			} else {
				action += '-top';
			}
			label = target?.innerText;
		} else if (target.matches('#primeai_button') || target.matches('#primeai_button2')) {
			action = 'primeai-size-guide';
		} else if (target.matches('[data-section-type=recently-viewed-products]')) {
			action = 'recently-viewed';
		} else if (target.matches('.ProductRecommendations')) {
			action = 'product-recommendations';
		} else if (target.matches('.CartUpsell [data-product-handle]')) {
			action = 'cart-upsell';
			label = target.dataset.productHandle
		} else {
			return;
		}
		
		if (gtag) gtag('event', 'click', { event_category: action, event_label: label });
	});

	
	var abval = parseInt(Cookies.get('abval')) % 10;
	if (isNaN(abval)) abval = parseInt(Math.random() * 10);
	document.documentElement.dataset.abval = abval;
	Cookies.set('abval', document.documentElement.dataset.abval, { secure: true, sameSite: 'none' });
	document.addEventListener('trackingLoaded', e => { if (gtag) gtag('event', 'abval_'+abval) });
})();